import { useEffect, useState } from "react"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { useCustomQuery } from "./useCustomQuery"
import { isAdminPortal } from "@/utilities/domain"

export function useConfigurationBranch(enabled = true) {
  const companyAdmin = enabled && isAdminPortal()
  const [branchId, setBranchId] = useState<number | null>(null)
  const { data } = useCustomQuery(["configuration-branches"], "branches/all", {
    enabled: companyAdmin,
  })
  const branches = (Array.isArray(data) ? data : data?.data || []) as {
    id: number
    name: string
  }[]

  useEffect(() => {
    if (companyAdmin && !branchId && branches.length) {
      setBranchId(Math.min(...branches.map((branch) => branch.id)))
    }
  }, [companyAdmin, branchId, branches])

  const branchSelector = companyAdmin ? (
    <FormControl size="small" sx={{ maxWidth: 320 }}>
      <InputLabel id="configuration-branch-label">Branch</InputLabel>
      <Select
        labelId="configuration-branch-label"
        label="Branch"
        value={branchId || ""}
        onChange={(event) => setBranchId(Number(event.target.value))}
      >
        {branches.map((branch) => (
          <MenuItem key={branch.id} value={branch.id}>
            {branch.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  ) : null

  return {
    branchId,
    ready: !companyAdmin || branchId !== null,
    branchSelector,
    settingsUrl: (url: string) =>
      companyAdmin && branchId ? `${url}?branch_id=${branchId}` : url,
  }
}
